export default __webpack_public_path__ + "static/media/screen2.ccba85be.png";